import { actionCreatorFactory } from 'typescript-fsa';
import { History } from 'history';
import { ISearchParamName, ISearchParamNameAndValue } from './router.interface';

export namespace RouterAction {
  const actionCreator = actionCreatorFactory('Router');

  export const addParam = actionCreator<ISearchParamNameAndValue>('ADD_PARAM');
  export const removeParam = actionCreator<ISearchParamName>('REMOVE_PARAM');
  export const addParamValue = actionCreator<ISearchParamNameAndValue>('ADD_PARAM_VALUE');
  export const removeParamValue = actionCreator<ISearchParamNameAndValue>('REMOVE_PARAM_VALUE');

  interface ILocationState {
    locationState?: unknown;
  }
  interface ILocationStateAndNewSegment extends ILocationState {
    segment: string | number;
  }

  export const addLastPathParam = actionCreator<ILocationStateAndNewSegment>('ADD_LAST_PATH_PARAM');
  export const removeLastPathParam = actionCreator<ILocationState>('REMOVE_LAST_PATH_PARAM');
  export const updateLastPathParam = actionCreator<ILocationStateAndNewSegment>('UPDATE_LAST_PATH_PARAM');
  export const push = actionCreator<Parameters<History['push']>>('PUSH');
  export const replace = actionCreator<Parameters<History['replace']>>('REPLACE');
  export const clearLocationState = actionCreator('CLEAR_LOCATION_STATE');
}
